import { t } from 'i18next';
import MapPin, { MapIconType } from './pin/MapPin';
import {
  getMapPinProps,
  getOperationStatusTranslationKey,
  WfOperationStatus,
} from 'src/api/wf/models/enums/WfOperationtStatus';

export type MapLegendProps = {
  className?: string;
};

const WF_MapLegend = (props: MapLegendProps) => {
  return (
    <div className={'grid grid-cols-4 ' + (props.className ? props.className : '')}>
      {[
        WfOperationStatus.Entrapment,
        WfOperationStatus.PartsReplace,
        WfOperationStatus.FloodResponse,
        WfOperationStatus.OnCall,
        WfOperationStatus.SiteInaccessible,
        WfOperationStatus.PowerOutageAcOff,
        WfOperationStatus.OtherAlert,
        WfOperationStatus.RecoveryCompleted,
      ].map((status) => (
        <div key={status} className="flex justify-start">
          <MapPin {...getMapPinProps(status)} />
          <div className="content-center text-sm text-gray-800">
            {t(getOperationStatusTranslationKey(status))}
          </div>
        </div>
      ))}
      <div className="flex justify-start">
        <div>
          <MapPin iconType={MapIconType.hbs} />
        </div>
        <div className="content-center text-sm text-gray-800">{t('wf.sites.map.icons.1')}</div>
      </div>
      <div className="flex justify-start">
        <div className="px-[2px]">
          <MapPin iconType={MapIconType.elecare} />
        </div>
        <div className="content-center text-sm text-gray-800">{t('wf.sites.map.icons.2')}</div>
      </div>
      <div className="flex justify-start">
        <MapPin
          {...{
            fillColor: 'text-white',
            lineColor: 'text-black',
            dotColor: 'bg-white border border-black',
          }}
        />
        <div className="content-center text-sm text-gray-800">{t('wf.sites.map.icons.3')}</div>
      </div>
      <div className="flex justify-start">
        <MapPin {...{ fillColor: 'text-white' }} />
        <div className="content-center text-sm text-gray-800">{t('wf.sites.map.reserved')}</div>
      </div>
      <div className="flex justify-start">
        <MapPin iconType={MapIconType.currentUserLocation} />
        <div className="content-center text-sm text-gray-800">{t('wf.sites.map.userLocation')}</div>
      </div>
      <div className="flex justify-start">
        <MapPin iconType={MapIconType.worker} workerId={0} hideNumber={true} />
        <div className="content-center text-sm text-gray-800">
          {t('wf.sites.map.workerLocation')}
        </div>
      </div>
      <div className="flex justify-start">
        <MapPin iconType={MapIconType.office} workerId={0} hideNumber={true} />
        <div className="content-center text-sm text-gray-800">{t('wf.common.salesOffice')}</div>
      </div>
    </div>
  );
};

export default WF_MapLegend;
